function handleCartEvents(event) {
    function checkButton() {
        const buttons = document.querySelectorAll(".cd-buy-button.cd-main-button.freegift");  
        if (buttons.length === 0) {
            requestAnimationFrame(checkButton); 
            return;
        }
        buttons.forEach((button) => {
            let addText = button.querySelector('.add-text');

            button.innerHTML = `  
                <span>Elige tu talla</span>
            `; 
        });
    }

    checkButton();
}

window.addEventListener('OpusCartChange', handleCartEvents);
window.addEventListener('OpusOpenCartState', handleCartEvents);
